import { useQuery } from "@tanstack/react-query";
import { fetchQuickOffers, fetchStorePromotions } from "../api/homeApi";

export const useQuickOffers = ({ storeUuid, token } = {}) => {
  const { data, isLoading, error } = useQuery({
    queryKey: ["quick-offers", { storeUuid }],
    queryFn: () => fetchQuickOffers({ storeUuid, token }),
    enabled: !!storeUuid && !!token,
    staleTime: 5_000,
    refetchInterval: 30_000,
  });

  // Promotions share the Coupons tab with quick offers. Their failure must not
  // hide the quick offers, so only quick-offer errors are surfaced.
  const { data: promotionsData, isLoading: isPromotionsLoading } = useQuery({
    queryKey: ["store-promotions", { storeUuid }],
    queryFn: () => fetchStorePromotions({ storeUuid, token }),
    enabled: !!storeUuid && !!token,
    staleTime: 5_000,
    refetchInterval: 30_000,
  });

  return {
    quickOffersData: data ?? null,
    promotionsData: promotionsData ?? null,
    isQuickOffersLoading: isLoading || isPromotionsLoading,
    quickOffersError: error ?? null,
  };
};
